function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import CommandInterceptor from 'diagram-js/lib/command/CommandInterceptor';
import { is, isInput } from 'dmn-js-shared/lib/util/ModelUtil';
/**
 * Makes sure allowed values are removed if type is set to
 * something other than string.
 */

var AllowedValuesUpdateBehavior = /*#__PURE__*/function (_CommandInterceptor) {
  _inherits(AllowedValuesUpdateBehavior, _CommandInterceptor);

  var _super = _createSuper(AllowedValuesUpdateBehavior);

  function AllowedValuesUpdateBehavior(eventBus, modeling) {
    var _this;

    _classCallCheck(this, AllowedValuesUpdateBehavior);

    _this = _super.call(this, eventBus);

    _this.postExecuted('element.updateProperties', function (event) {
      var _event$context = event.context,
          element = _event$context.element,
          properties = _event$context.properties;
      var actualProperties = isInput(element) ? properties.inputExpression : properties;

      if (actualProperties && actualProperties.typeRef && actualProperties.typeRef !== 'string') {
        var target = is(element, 'dmn:LiteralExpression') ? element.$parent : element; // delete allowed values

        modeling.editAllowedValues(target, null);
      }
    });

    return _this;
  }

  return _createClass(AllowedValuesUpdateBehavior);
}(CommandInterceptor);

export { AllowedValuesUpdateBehavior as default };
AllowedValuesUpdateBehavior.$inject = ['eventBus', 'modeling'];
//# sourceMappingURL=AllowedValuesUpdateBehavior.js.map